/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSubLimitPayloadDto
 */
export interface UpdateSubLimitPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateSubLimitPayloadDto
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubLimitPayloadDto
     */
    peril?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubLimitPayloadDto
     */
    amount?: string;
}

/**
 * Check if a given object implements the UpdateSubLimitPayloadDto interface.
 */
export function instanceOfUpdateSubLimitPayloadDto(value: object): value is UpdateSubLimitPayloadDto {
    return true;
}

export function UpdateSubLimitPayloadDtoFromJSON(json: any): UpdateSubLimitPayloadDto {
    return UpdateSubLimitPayloadDtoFromJSONTyped(json, false);
}

export function UpdateSubLimitPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSubLimitPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'country': json['country'] == null ? undefined : json['country'],
        'peril': json['peril'] == null ? undefined : json['peril'],
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function UpdateSubLimitPayloadDtoToJSON(json: any): UpdateSubLimitPayloadDto {
    return UpdateSubLimitPayloadDtoToJSONTyped(json, false);
}

export function UpdateSubLimitPayloadDtoToJSONTyped(value?: UpdateSubLimitPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'country': value['country'],
        'peril': value['peril'],
        'amount': value['amount'],
    };
}

